// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.domain-manager {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
  }

  .domain-manager-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 800px;
    margin: 0 auto;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .domain-group {
    margin-bottom: 15px;
  }
  
  .domain-group label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
    text-align: left;
  }
  
  .domain-group input {
    width: 100%;
    padding: 8px 0 8px 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .alert-note {
    /* font-size: 0.9em;
    color: #666 !important;
    text-align: left;
    margin: 0 !important; */
    font-size: 13px !important;
    font-style: italic;
    color: #44a67e !important;
    font-weight: 600;
    text-align: left;
    margin: 0 !important;
    margin-top: 5px !important;
  }
  
  .form-buttons {
    margin-top: 15px;
  }
  
  .btn {
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .btn-add {
    background-color: #44a67e;
    color: #fff;
  }
  
  .btn-cancel {
    background-color: #fb3d4e;
    color: #fff;
    margin-left: 10px;
  }
  

  .delete-domain-manager {
    background-color: #fb3d4e;
    padding: 8px 10px;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 5px;
  }

  .delete-domain-manager:hover {
    background-color: #c82333;
  }


  /* Response message */
  .addDomainResponse {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
  }

  .addDomainResponse p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
  }
  
  .wrap-domain-manager {
    margin: 0 40px;
  }

   /* Table Styling */
   .domain-manager-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .domain-manager-table th,
  .domain-manager-table td {
    padding: 12px 15px;
    border: 1px solid #ddd;
    font-size: 14px;
  }
  
  .domain-manager-table th {
    background-color: #f4f4f4;
    color: #373435;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
  }
  
  .domain-manager-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .domain-manager-table tbody tr:hover {
    background-color:  rgba(255, 204, 41, 0.2);
  }
  
  .domain-manager-table td {
    color: #373435;
  }
  
  .domain-manager-table tbody tr:last-child td {
    border-bottom: 2px solid #ffcc29;
  }

  /* Expand Button */
  .domain-expand-btn {
    background: #373435;
    color: #ffcc29;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .domain-expand-btn:hover {
    background: #ffcc29;
    color: #373435;
  }
  
  /* Expanded Row */
  .domain-expanded-row {
    background-color: #eef7ff;
  }
  
  .domain-expanded-content {
    padding: 10px;
  }`, "",{"version":3,"sources":["webpack://./src/components/DomainManager/DomainManager.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE;;;2BAGuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;EACnB;;;EAGA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;GAEC,kBAAkB;GAClB;IACC,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,kBAAkB;EAClB;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf","sourcesContent":[".domain-manager {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .domain-manager-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .domain-group {\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .domain-group label {\r\n    display: block;\r\n    font-weight: bold;\r\n    margin-bottom: 5px;\r\n    text-align: left;\r\n  }\r\n  \r\n  .domain-group input {\r\n    width: 100%;\r\n    padding: 8px 0 8px 6px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .alert-note {\r\n    /* font-size: 0.9em;\r\n    color: #666 !important;\r\n    text-align: left;\r\n    margin: 0 !important; */\r\n    font-size: 13px !important;\r\n    font-style: italic;\r\n    color: #44a67e !important;\r\n    font-weight: 600;\r\n    text-align: left;\r\n    margin: 0 !important;\r\n    margin-top: 5px !important;\r\n  }\r\n  \r\n  .form-buttons {\r\n    margin-top: 15px;\r\n  }\r\n  \r\n  .btn {\r\n    padding: 10px 15px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .btn-add {\r\n    background-color: #44a67e;\r\n    color: #fff;\r\n  }\r\n  \r\n  .btn-cancel {\r\n    background-color: #fb3d4e;\r\n    color: #fff;\r\n    margin-left: 10px;\r\n  }\r\n  \r\n\r\n  .delete-domain-manager {\r\n    background-color: #fb3d4e;\r\n    padding: 8px 10px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-left: 5px;\r\n  }\r\n\r\n  .delete-domain-manager:hover {\r\n    background-color: #c82333;\r\n  }\r\n\r\n\r\n  /* Response message */\r\n  .addDomainResponse {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .addDomainResponse p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n  \r\n  .wrap-domain-manager {\r\n    margin: 0 40px;\r\n  }\r\n\r\n   /* Table Styling */\r\n   .domain-manager-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .domain-manager-table th,\r\n  .domain-manager-table td {\r\n    padding: 12px 15px;\r\n    border: 1px solid #ddd;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .domain-manager-table th {\r\n    background-color: #f4f4f4;\r\n    color: #373435;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .domain-manager-table tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .domain-manager-table tbody tr:hover {\r\n    background-color:  rgba(255, 204, 41, 0.2);\r\n  }\r\n  \r\n  .domain-manager-table td {\r\n    color: #373435;\r\n  }\r\n  \r\n  .domain-manager-table tbody tr:last-child td {\r\n    border-bottom: 2px solid #ffcc29;\r\n  }\r\n\r\n  /* Expand Button */\r\n  .domain-expand-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .domain-expand-btn:hover {\r\n    background: #ffcc29;\r\n    color: #373435;\r\n  }\r\n  \r\n  /* Expanded Row */\r\n  .domain-expanded-row {\r\n    background-color: #eef7ff;\r\n  }\r\n  \r\n  .domain-expanded-content {\r\n    padding: 10px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
